<template>
	<div class="form-group">
		<label
			:for="'StringInputUploadExplicit' + field.form_field_id + personNumber"
			class="d-block col-form-label-sm"
		>
			{{ field.name }}
		</label>
		<b-form-input
			:id="'StringInputUploadExplicit' + field.form_field_id + personNumber"
			:value="value"
			name="example-input-1"
			aria-describedby="input-1-live-feedback"
			:state="isValidate"
			@input="$emit('input', $event)"
			@change="$emit('change', $event)"
			@focus="$emit('focus', $event)"
			@blur="$emit('blur', value)"
		/>
		<b-form-invalid-feedback id="input-1-live-feedback">
			Заполните поле корректно
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	name: 'StringInputUploadExplicit',
	props: {
		field: {
			type: Object,
			default: () => {
			},
		},
		value: { default: null },
		personNumber: { default: null },
	},
	data() {
		return {
			isValidate: null,
		};
	},
	methods: {
		/**
		 * Проверяем валидность по библиотеке vuelidate
		 * @param form Oбъект, сгенерированный vuelidate, содержит инфу об ошибках
		 */
		checkValidation(form) {
			this.isValidate = typeof form[this.field.slug]?.$error !== 'undefined' ? !form[this.field.slug]?.$error : true;
			return this.isValidate;
		},
		approveValidation() {
			this.isValidate = true;
		},
	},

};
</script>
